import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { config } from '../shared/utils/config';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // private auth_url = 'http://10.76.174.227:5004/api';
  private auth_url = 'http://localhost:5004/api';
  private loginUrl    = this.auth_url + config.LOGIN_URL;
  private logoutUrl   = this.auth_url + config.LOGOUT_URL;


  constructor(private http: HttpClient, private router: Router, private activeRoute: ActivatedRoute) { }

  loginUser(user: any) {
    return this.http.post<any>(this.loginUrl, user);
  }

  logOut() {
    this.http.post(this.logoutUrl, {}).subscribe((logoutData) => {
      console.log('success', logoutData)
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/signout']);
    }, (error) => {
      console.log('Error in logging out', error);
    });
  }
  
  getToken() {
    return localStorage.getItem('token');
  }

  // KPE-865 BY ML 27JUN25 Code moved from main-app service to here
  private authUrl = config.AUTH_API_URL;

  // Create a BehaviorSubject to manage the state
  private userRolesSubject = new BehaviorSubject<any>([]);
  public userRoles$ = this.userRolesSubject.asObservable();

  private userDetailsSubject = new BehaviorSubject<any>({});
  private userPermissionsSubject = new BehaviorSubject<any>([]);
  
  // Getter to access the current roles
  get userRoles(): any {
    return this.userRolesSubject.getValue();
  }

  // Setter to update roles
  set userRoles(roles: any) {
    this.userRolesSubject.next(roles);
  }

  hasUserRole(role: string){
    return this.userRoles.includes(role);
  }

  hasRoles(required: string[]): boolean {
    return required.every(role => this.userRoles.includes(role));
  }

  // Getter to access the current user details
  get userDetails(): any {
    return this.userDetailsSubject.getValue();
  }

  // Setter to update user details
  set userDetails(roles: any) {
    this.userDetailsSubject.next(roles);
  }

  // Getter to access the current user permissions
  get userPermissions(): any {
    return this.userPermissionsSubject.getValue();
  }

  // Setter to update user permissions
  set userPermissions(roles: any) {
    this.userPermissionsSubject.next(roles);
  }

  checkIfUserRegistered(userDetails = {}) {
    return this.http.post<any>(`${this.authUrl}users/check-user`, userDetails);
  }
  getProfileDetails(userId) {
    // return this.http.get<any>(`https://avalara.okta.com/api/v1/users/${userId}/profile`);
    return this.http.get<any>(`https://avalara.okta.com/oauth2/userInfo`);
  }
}
